import { Container, Contenttable, Chat, ChatTitle } from "./styled";
import LoGoGreen from "../../../../assets/img/Langding/LoGoGreen.svg";
import Chart from "../../../../assets/img/Langding/Chat.svg";

const Regenerative = () => {
  return (
    <Container>
      <Contenttable>
        <div>
          <h1>TOKENOMIC</h1>
          <p>
            TOTAL SUPPLY: <span>500.000.000</span>
          </p>
        </div>
        <div>
          <table>
            <tr>
              <th></th>
              <th></th>
              <th></th>
              <th>TOKEN</th>
              <th>VESTING</th>
            </tr>
            {tableArr.map((item) => {
              return (
                <tr key={item.id}>
                  <td>{item.id}</td>
                  <td>
                    <p>{item.status}</p>
                  </td>
                  <td>{item.value}</td>
                  <td>{item.tokent}</td>
                  <td>{item.time}</td>
                </tr>
              );
            })}
          </table>
        </div>
      </Contenttable>
      <Chat>
        <ChatTitle>
          <h3>CHART</h3>
          <img src={LoGoGreen} alt="" />
        </ChatTitle>
        <img src={Chart} alt="" />
        <h4>
          <p>
            <span></span>User Stake & Reward
          </p>
          63%
        </h4>
        <h4>
          <p>
            <span></span>Private Investor
          </p>
          08%
        </h4>
        <h4>
          <p>
            <span></span>Daily Reward
          </p>
          08%
        </h4>
        <h4>
          <p>
            <span></span>Marketing & DEV
          </p>
          03%
        </h4>
        <h4>
          <p>
            <span></span>Forest Insurance Fund
          </p>
          03%
        </h4>
        <h4>
          <p>
            <span></span>Liquidity for Binance Smart Chain (BSC)
          </p>
          05%
        </h4>
        <h4>
          <p>
            <span></span>Reward for Liquidity Providers, Escrow with Vesting
          </p>
          10%
        </h4>
      </Chat>
    </Container>
  );
};
export default Regenerative;

const tableArr = [
  {
    id: "01",
    status: "Private Investor",
    value: "8%",
    tokent: "40.000.000",
    time: "5 Years",
  },
  {
    id: "02",
    status: "Marketing & DEV",
    value: "3%",
    tokent: "15.000.000",
    time: "10 Years",
  },
  {
    id: "03",
    status: "Daily Reward",
    value: "8%",
    tokent: "40.000.000",
    time: "Pool Reward",
  },
  {
    id: "04",
    status: "Liquidity for Binance Smart Chain (BSC)",
    value: "5%",
    tokent: "25.000.000",
    time: "Pool Reward",
  },
  {
    id: "05",
    status: "Reward for Liquidity Providers, Escrow with Vesting",
    value: "10%",
    tokent: "50.000.000",
    time: "Pool Reward",
  },
  {
    id: "06",
    status: "Forest Insurance Fund",
    value: "3%",
    tokent: "15.000.000",
    time: "Pool Reward",
  },
  {
    id: "07",
    status: "User Stake & Reward",
    value: "63%",
    tokent: "315.000.000",
    time: "Pool Reward",
  },
];
